// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationV2UserGetUsersByConnectionConnectionNameGetUsersByConnectionResponse {
    static getAttributeTypeMap() {
        return AuthenticationV2UserGetUsersByConnectionConnectionNameGetUsersByConnectionResponse.attributeTypeMap;
    }
}
AuthenticationV2UserGetUsersByConnectionConnectionNameGetUsersByConnectionResponse.discriminator = undefined;
AuthenticationV2UserGetUsersByConnectionConnectionNameGetUsersByConnectionResponse.additionalProperties = false;
AuthenticationV2UserGetUsersByConnectionConnectionNameGetUsersByConnectionResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=authenticationV2UserGetUsersByConnectionConnectionNameGetUsersByConnectionResponse.js.map